﻿const BaseRouter = require("@cirrus/legacy/app-common/framework/router")
const CustomerInfo = require("@cirrus/legacy/app-common/customer-info.js").default
const {
  checkLoginPageAllowed,
  checkStartPageAllowed,
  getSamlUrl,
} = require("@cirrus/legacy/app-common/utils/redirectSaml")

const withRedirect = (routes, canPass, redirect) =>
  Object.keys(routes).reduce(
    (wrapped, route) => ({
      ...wrapped,
      [route](...args) {
        if (canPass()) {
          routes[route].bind(this)(...args)
        } else {
          redirect()
        }
      },
    }),
    {},
  )

const Router = BaseRouter.extend({
  routes: {
    "reset-password": "startResetPassword",
    "reset-password-confirm/:token(/)": "startResetPasswordConfirm",
    "reset-password-confirm/:token?newLang=:lang": "startResetPasswordConfirm",
    saml: "startSaml",
    keycode: "startKeycode",
    role: "chooseRole",
    "master-login": "startMasterLoginPage",
    "external-login": "startExternalLoginPage",
    "": "startLoginPage",
    login: "startLoginWithCredentials",
    "*notFound": "notFound",
  },
  isSamlEnabled() {
    const canUseSaml = CustomerInfo.get("saml")

    return canUseSaml && canUseSaml.enabled
  },
  isKeycodeEnabled() {
    return Boolean(CustomerInfo.get("keycode"))
  },
  startKeycode(optional) {
    if (this.isKeycodeEnabled()) {
      const m = this.changeModule("Keycode")

      m.start({ rootRoute: "#keycode" })
    } else {
      window.location.href = "#"
    }
  },
  ...withRedirect(
    {
      startLoginPage(optional) {
        if (this.isSamlEnabled() && this.isFirstLoad) {
          window.location.href = "#saml"
        } else {
          const m = this.changeModule("StartLogin")

          m.start({ optionalRoute: optional, rootRoute: "#" })
        }
      },
      startSaml(optional) {
        if (this.isSamlEnabled()) {
          const m = this.changeModule("Saml")

          m.start({ rootRoute: "#saml" })
        } else {
          window.location.href = "#"
        }
      },
    },
    () => checkStartPageAllowed(CustomerInfo.get("saml")),
    () => (window.location.href = getSamlUrl()),
  ),
  ...withRedirect(
    {
      startLoginWithCredentials(optional) {
        const m = this.changeModule("StartLogin")

        m.start({ optionalRoute: optional, rootRoute: "#" })
      },
      startResetPassword(optional) {
        const m = this.changeModule("ResetPassword")

        m.start({ route: optional, rootRoute: "#reset-password" })
      },
      startResetPasswordConfirm(token, lang) {
        const m = this.changeModule("ResetPasswordConfirm")

        m.start({ token, rootRoute: "#reset-password-confirm" })
      },
    },
    () => checkLoginPageAllowed(CustomerInfo.get("saml")),
    () => (window.location.href = "404"),
  ),
  startMasterLoginPage(optional) {
    const m = this.changeModule("StartMasterLogin")

    m.start({ route: optional, rootRoute: "#master-login" })
  },
  startExternalLoginPage(optional) {
    const m = this.changeModule("StartExternalLogin")

    m.start({ route: optional, rootRoute: "#external-login" })
  },
  chooseRole(optional) {
    if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1) {
      window.onunload = function () {}
    }

    if (sessionStorage.length === 0) {
      return window.location.replace("/")
    }

    const m = this.changeModule("RolePage")

    m.start({ route: optional, rootRoute: "#role" })
  },
})

module.exports = Router
